/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update feature release state
 * @export
 * @interface UpdateReleaseStateRequest
 */
export interface UpdateReleaseStateRequest {
    /**
     * Release state: ALPHA, BETA, GA, PLANNED
     * @type {string}
     * @memberof UpdateReleaseStateRequest
     */
    releaseState: string;
}

/**
 * Check if a given object implements the UpdateReleaseStateRequest interface.
 */
export function instanceOfUpdateReleaseStateRequest(value: object): value is UpdateReleaseStateRequest {
    if (!('releaseState' in value) || value['releaseState'] === undefined) return false;
    return true;
}

export function UpdateReleaseStateRequestFromJSON(json: any): UpdateReleaseStateRequest {
    return UpdateReleaseStateRequestFromJSONTyped(json, false);
}

export function UpdateReleaseStateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReleaseStateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'releaseState': json['releaseState'],
    };
}

export function UpdateReleaseStateRequestToJSON(json: any): UpdateReleaseStateRequest {
    return UpdateReleaseStateRequestToJSONTyped(json, false);
}

export function UpdateReleaseStateRequestToJSONTyped(value?: UpdateReleaseStateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'releaseState': value['releaseState'],
    };
}

